import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { BellIcon, CursorClickIcon } from '@heroicons/vue/outline';
import type { AuraAction } from '@/types';
import AuraRichText from './AuraRichText.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraActionCard',
  props: {
    action: { type: Object, required: true },
    disabled: { type: Boolean, required: false },
    loading: { type: Boolean, required: false }
  },
  emits: ["execute"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const { t } = useI18n();

const emit = __emit;

const isClickable = computed(
    () =>
        props.action.executionOwner === 'aura' &&
        Boolean(props.action.followUpQuestion?.trim()) &&
        !props.disabled &&
        !props.loading,
);

const priority = computed(() => {
    if (props.action.priority === 'high') {
        return { label: t('aura.cards.action.priority.high'), color: '#48DDC3', text: '#242B59' };
    }

    if (props.action.priority === 'low') {
        return { label: t('aura.cards.action.priority.low'), color: '#E5E7EB', text: '#626468' };
    }

    return { label: t('aura.cards.action.priority.medium'), color: '#F5B041', text: '#242B59' };
});

const actionIcon = computed(() => (isClickable.value ? CursorClickIcon : BellIcon));

const activate = () => {
    if (isClickable.value) emit('execute', props.action);
};

const __returned__ = { props, t, emit, isClickable, priority, actionIcon, activate, AuraRichText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})